import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "children"];
import { useContext } from 'react';
import { ButtonWrapper } from '../ButtonWrapper/ButtonWrapper';
import styled from 'foundations-theming/utils';
import { DialogContext } from '../Dialog/DialogContext';
import { PanelContext } from '../../context/PanelContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useWizardFooterContext } from '../Wizard/WizardFooterProvider';
import { StyledButton, StyledButtonTextContainer } from '../Button/PrivateButton';
import { BREAKPOINTS } from '../Grid/Grid.types';
import { deepMerge } from '../../utils/deepMerge';
import { rgba } from '../../utils/color';
import { jsx as _jsx } from "react/jsx-runtime";
//TODO Color token does not exist: PANTERA
const LIGHTBOX_BG_COLOR = '#2d3e50';
const ALIGNMENT_OPTIONS = {
  between: 'between',
  left: 'start',
  center: 'center',
  right: 'end'
};
export const StyledFooter = styled.footer.withConfig({
  displayName: "DialogFooter__StyledFooter",
  componentId: "sc-17mdcw9-0"
})(({
  $align,
  theme,
  $cssStyles,
  $styleOverrides
}) => {
  const use = useContext(DialogContext).use;
  const isConversational = use === 'conversational';
  const isSidebar = use === 'sidebar';
  const isLightbox = use === 'lightbox';
  const isPanel = useContext(PanelContext).inPanel;
  return deepMerge(Object.assign({
    flexGrow: 0,
    flexShrink: 0,
    color: isLightbox ? 'inherit' : undefined,
    backgroundColor: (isPanel || isSidebar) && !isLightbox ? theme.color['fill-surface-raised'] : isLightbox ? `${rgba(LIGHTBOX_BG_COLOR, 0.89)}` : theme.color['fill-surface-default'],
    justifyContent: $align === 'between' ? 'space-between' : $align,
    alignItems: 'center',
    paddingInline: isLightbox ? theme.space['1400'] : theme.space['1000'],
    paddingBlock: theme.space['600'],
    paddingBlockStart: isConversational ? theme.space['0'] : undefined,
    zIndex: isPanel ? 1 : undefined,
    borderBlockStart: isPanel && !isLightbox ? `${theme.borderWidth['100']} solid ${theme.color['border-container-default']}` : undefined,
    textAlign: 'left',
    [`& ${StyledButton} ${StyledButtonTextContainer} span`]: {
      [`@media only screen and (max-width: ${BREAKPOINTS.sm}px)`]: {
        width: '100%',
        textAlign: 'center'
      }
    }
  }, $cssStyles, {
    [`> * + *`]: {
      [`@media only screen and (min-width: rem-calc(map-get($grid-breakpoints, sm) + 1))`]: {
        marginInlineStart: theme.space['300']
      }
    }
  }), $styleOverrides);
});
export function DialogFooter(_ref) {
  var _wizardFooterContext$;
  let {
      align = 'left',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const wizardFooterContext = useWizardFooterContext();
  const {
    inPanel
  } = useContext(PanelContext);

  // Only apply wizard footer style overrides if we're in a panel context
  // This ensures that:
  // - Wizards in panels get their footer styling
  // - WizardFooters (which set inPanel: true) get their footer styling
  // - User DialogFooters inside modals don't get wizard styling (inPanel: false)
  const footerStyleOverrides = inPanel ? (_wizardFooterContext$ = wizardFooterContext === null || wizardFooterContext === void 0 ? void 0 : wizardFooterContext.footerStyleOverrides) !== null && _wizardFooterContext$ !== void 0 ? _wizardFooterContext$ : {} : {};
  return /*#__PURE__*/_jsx(StyledFooter, Object.assign({}, domProps, {
    $align: align,
    $cssStyles: cssStyles,
    $styleOverrides: footerStyleOverrides,
    children: /*#__PURE__*/_jsx(ButtonWrapper, {
      justify: ALIGNMENT_OPTIONS[align],
      children: children
    })
  }));
}